import {ProvidersMedicalGuide} from 'domain/usecases';
import {PlanTypeEnum} from 'presentation/constants';

enum IdentifierTelehealthEnum {
	DIGITAL_TELECONSULTATION = 'TELECONSULTA - DIGITAL',
}

enum NetworkTypes {
	TELEMEDICINE = 'telemedicina',
	SELF_NETWORK = 'redePropria',
	ACCREDITED_NETWORK = 'redeCredenciada',
	NOTRE_DAME_HAPVIDA = 'redeNotreDameHapvida',
	ACCREDITED_NOTRE_DAME = 'redeCredenciadaNotreDame',
}

type GroupedProvidersByNetworkProps = {
	telemedicina: ProvidersMedicalGuide[];
	redePropria: ProvidersMedicalGuide[];
	redeCredenciada: ProvidersMedicalGuide[];
};

type RenderGroupsTypesProps = {
	title: string;
	list: ProvidersMedicalGuide[];
	type: NetworkTypes;
};

type GuideFiltersBackup = {
	type: PlanTypeEnum;
	selectedUf: string;
	selectedCity: string;
	selectedService: string;
	selectedSpecialty: string;
	selectedNetworkCode: number;
	hasSelectedTpRede: boolean;
};

interface ContentCardsProps {
	$isEmpty?: boolean;
}

export type {
	GroupedProvidersByNetworkProps,
	RenderGroupsTypesProps,
	GuideFiltersBackup,
	ContentCardsProps,
};

export {IdentifierTelehealthEnum, NetworkTypes};
